import { Reveal } from "./Reveal";
import { MapPin } from "lucide-react";

const FACILITY_IMG =
  "https://images.pexels.com/photos/36397860/pexels-photo-36397860.jpeg";

const stats = [
  { value: "11", unit: "Acres", label: "Integrated site" },
  { value: "36,000", unit: "MT / yr", label: "Annual capacity" },
  { value: "99.97", unit: "%+", label: "Refined lead purity" },
  { value: "0", unit: "", label: "Landfill / discharge" },
];

const badges = ["GPCB Compliant", "MoEF Approved", "Zero-Discharge"];

export const Facility = () => (
  <section
    id="facility"
    data-testid="facility-section"
    className="border-y border-[var(--mx-line)] bg-[var(--mx-surface-2)]"
  >
    <div className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
      <Reveal>
        <div className="mb-14 flex items-center gap-4 font-mono-tech text-xs uppercase tracking-[0.25em] text-[var(--mx-ink-2)]">
          <span className="h-px w-10 bg-[var(--mx-copper)]" />
          03 — The Facility
        </div>
      </Reveal>

      <div className="grid gap-12 md:grid-cols-12 md:gap-16">
        <div className="md:col-span-6">
          <Reveal>
            <h2 className="font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter text-[var(--mx-ink)] md:text-7xl">
              Built for scale,
              <br />
              built <span className="text-metal">clean</span>
            </h2>
            <p className="mt-8 max-w-md text-base leading-relaxed text-[var(--mx-ink-2)] md:text-lg">
              Our integrated recycling and manufacturing plant spans 11 acres in
              Bharuch, Gujarat, with an annual capacity of 36,000 MT of refined
              lead and lead alloys — fully compliant with Gujarat Pollution
              Control Board (GPCB) and Ministry of Environment &amp; Forests
              (MoEF) norms.
            </p>

            <div className="mt-8 flex items-center gap-3 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink)]">
              <MapPin size={16} className="text-[var(--mx-copper)]" />
              Sardarapura, Jambusar · Bharuch, Gujarat
            </div>

            <div className="mt-6 flex flex-wrap gap-3" data-testid="compliance-badges">
              {badges.map((b) => (
                <span
                  key={b}
                  className="rounded-full border border-[var(--mx-copper)]/30 bg-[var(--mx-copper)]/10 px-4 py-2 font-mono-tech text-[11px] uppercase tracking-widest text-[var(--mx-copper)]"
                >
                  {b}
                </span>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-6">
          <Reveal delay={0.1}>
            <div className="relative aspect-[16/11] overflow-hidden rounded-2xl bg-[var(--mx-charcoal)] ring-1 ring-[var(--mx-line)] shadow-[0_30px_80px_-45px_rgba(27,23,20,0.55)]">
              <img
                src={FACILITY_IMG}
                alt="Metalix recycling facility operations"
                className="absolute inset-0 h-full w-full object-cover opacity-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#100c09]/70 via-transparent to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>

      <Reveal delay={0.15}>
        <div className="mt-16 grid grid-cols-2 overflow-hidden rounded-2xl border border-[var(--mx-line)] bg-[var(--mx-surface)] md:grid-cols-4">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`p-8 md:p-10 ${
                i !== 0 ? "border-l border-[var(--mx-line)]" : ""
              }`}
            >
              <div className="flex items-baseline gap-1 font-display text-4xl font-black tracking-tighter text-[var(--mx-ink)] md:text-5xl">
                {s.value}
                <span className="text-lg text-[var(--mx-copper)] md:text-xl">
                  {s.unit}
                </span>
              </div>
              <div className="mt-3 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default Facility;
